import { render, staticRenderFns } from "./editbanben.vue?vue&type=template&id=3b7422a4&scoped=true"
import script from "./editbanben.vue?vue&type=script&lang=js"
export * from "./editbanben.vue?vue&type=script&lang=js"
import style0 from "./editbanben.vue?vue&type=style&index=0&id=3b7422a4&prod&lang=css"
import style1 from "./editbanben.vue?vue&type=style&index=1&id=3b7422a4&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7422a4",
  null
  
)

export default component.exports